import { Injectable } from '@angular/core';
import Axios from 'axios' ;
import { SliderDto } from '../models/dtos/sliderDto';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';


@Injectable({
    providedIn: 'root',
})
export class SliderService {
 
      constructor(private http: HttpClient) { }
      
      public apiUrl = `${environment.apiUrl}/AdminDatas/`;
    
    private getHeaders() {
        const token = sessionStorage.getItem('token');
        return {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json'
        };
    }

    async getSliders(): Promise<SliderDto[]> {
        const { data } = await Axios.get(`${this.apiUrl}getSlider`, {
            headers: this.getHeaders()
        });
        return data;
    }


}